import React from 'react';
import {Container, Table} from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination';
import {flexRender, getCoreRowModel, useReactTable} from '@tanstack/react-table';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeftLong, faFileLines} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import './Pagination.css'
import ApiService from "../../api/ApiService";
import { formatBeijingTime } from "../../api/TimeService";

// 将 columns 和 data 放在组件外部，确保它们在函数作用域中可用
const data = [
    {
        key: '1',
        transactionType: '消耗',
        transactionDetails: '工作消耗：TABLE_DEMO_01',
        cost: '',
        transactionTime: '2025-06-16 14:25:00',
    },
    {
        key: '2',
        transactionType: '充值',
        transactionDetails: '充值：498',
        cost: '498.00',
        transactionTime: '2025-06-16 14:25:00',
    },
    {
        key: '3',
        transactionType: '其他-签到',
        transactionDetails: '签到获得额度',
        cost: '',
        transactionTime: '2025-06-16 14:25:00',
    },
    {
        key: '3',
        transactionType: '其他-签到',
        transactionDetails: '签到获得额度',
        cost: '',
        transactionTime: '2025-06-16 14:25:00',
    },


];

const columns = [
    {
        accessorKey: 'payType',
        header: '交易类型',
        Cell: ({cell}) => (
            <span style={{color: 'white',fontSize: '16px',}}>
        {cell.getValue()==='wx_native'?'微信':'支付宝'}
      </span>
        ),
    },
    {
        accessorKey: 'remark',
        header: '交易详情',
        Cell: ({cell}) => (
            <span style={{color: 'white',fontSize: '16px',}}>
        {cell.getValue()}
      </span>
        ),
    },

    {
        accessorKey: 'totalFee',
        header: '费用(元)',
        Cell: ({cell}) => (
            <span style={{color: 'white',fontSize: '16px',}}>
        {cell.getValue()/100}
      </span>
        ),
    },
    {
        accessorKey: 'created',
        header: '交易时间',
        Cell: ({cell}) => (
            <span style={{color: 'white',fontSize: '16px',}}>
         {formatBeijingTime(cell.getValue())}
      </span>
        ),
    },
];

const VipChargingList = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPages, setTotalPages] = React.useState(0);
    const [data, setData] = React.useState([]);
    const itemsPerPage = 10;
    const api = new ApiService();
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };


    // 请求数据并更新状态
    React.useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await api.orderRecords('0',itemsPerPage, currentPage);
                setData(result.data || []);
                if (currentPage===1 && (result.data===null||result.data.length===0)){
                    setTotalPages(0);
                }else {
                    setTotalPages(Math.ceil((result.extends?.total ? result.extends?.total : 1) / itemsPerPage));
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [currentPage, itemsPerPage]);
    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <Container>
            <div className={'pb-3'}>
                <div style={{alignItems:'start',display:'flex',}}>
                    <button style={{
                        color: '#101217',
                        border: 'none',
                        background: '#02C8E3',
                        borderRadius: '12px',
                        padding: '6px 22px',
                    }} onClick={() => {
                        navigate('/vipCenter?tab=MembershipPlans')
                    }}>
                        <span style={{marginRight: '10px'}}>
                        <FontAwesomeIcon icon={faArrowLeftLong} color={'#101217'} size={'1x'}/>
                      </span>
                        会员页
                    </button>
                </div>
                <div style={{background:'#15191E',padding:'24px',borderRadius:'20px',}}>
                    <h5 className={'mb-3'} style={{color: 'white',textAlign:'start',}}><span>
                    <FontAwesomeIcon icon={faFileLines} color={'#02C8E3'} size={'1x'}/> </span>
                        会员开通记录
                    </h5>
                    <Table borderless={true} responsive="lg" variant="dark" style={{'minWidth': '700px'}}>
                        <thead >
                        {table.getHeaderGroups().map(headerGroup => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map(header => (
                                    <th key={header.id}>
                                        {flexRender(header.column.columnDef.header, header.getContext())}
                                    </th>
                                ))}
                            </tr>
                        ))}
                        </thead>
                        <tbody>
                        {table.getRowModel().rows.map(row => (
                            <tr key={row.id}>
                                {row.getVisibleCells().map(cell => (
                                    <td key={cell.id}>
                                        {flexRender(cell.column.columnDef.Cell, cell.getContext())}
                                    </td>
                                ))}
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                    <Pagination className={'mt-3 mb-3 d-flex  justify-content-center justify-content-lg-end'}>
                        <Pagination.First
                            onClick={() => handlePageChange(1)}
                            disabled={currentPage === 1}/>
                        <Pagination.Prev
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        />
                        {totalPages <= 4
                            ? Array.from({length: totalPages}, (_, index) => (
                                <Pagination.Item
                                    key={index + 1}
                                    active={index + 1 === currentPage}
                                    onClick={() => handlePageChange(index + 1)}
                                >
                                    {index + 1}
                                </Pagination.Item>
                            ))
                            : [
                                // 第一页
                                <Pagination.Item
                                    key={1}
                                    active={1 === currentPage}
                                    onClick={() => handlePageChange(1)}
                                >
                                    {1}
                                </Pagination.Item>,

                                // 处理第一页和第二页的情况
                                (currentPage === 2 || currentPage === 1) && (
                                    <>
                                        <Pagination.Item
                                            key={2}
                                            active={currentPage === 2}
                                            onClick={() => handlePageChange(2)}
                                        >
                                            {2}
                                        </Pagination.Item>
                                        {totalPages > 3 && <Pagination.Ellipsis key="ellipsis-1" active={false}/>}
                                    </>
                                ),

                                // 处理中间页的情况
                                (currentPage > 2 && currentPage < totalPages - 1) && (
                                    <>
                                        <Pagination.Ellipsis key="ellipsis-1" active={false}/>
                                        <Pagination.Item
                                            key={currentPage}
                                            active
                                            onClick={() => handlePageChange(currentPage)}
                                        >
                                            {currentPage}
                                        </Pagination.Item>
                                        <Pagination.Ellipsis key="ellipsis-2" active={false}/>
                                    </>
                                ),

                                // 处理倒数第二页的情况
                                (currentPage === totalPages || currentPage === totalPages - 1) && (
                                    <>
                                        <Pagination.Ellipsis key="ellipsis-1" active={false}/>
                                        <Pagination.Item
                                            key={totalPages - 1}
                                            active={currentPage === totalPages - 1}
                                            onClick={() => handlePageChange(totalPages - 1)}
                                        >
                                            {totalPages - 1}
                                        </Pagination.Item>
                                    </>
                                ),

                                // 最后一页
                                totalPages > 1 && (
                                    <Pagination.Item
                                        key={totalPages}
                                        active={totalPages === currentPage}
                                        onClick={() => handlePageChange(totalPages)}
                                    >
                                        {totalPages}
                                    </Pagination.Item>
                                )
                            ]
                        }
                        {/*<Pagination.Ellipsis />*/}
                        <Pagination.Next
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        />
                        <Pagination.Last
                            onClick={() => handlePageChange(totalPages)}
                            disabled={currentPage === totalPages}
                        />
                    </Pagination>
                </div>
            </div>
        </Container>

    );
};

export default VipChargingList;